import { css } from "@emotion/react";
import type { ReactNode } from "react";

import { colors, icons } from "../..";
import { createStaticStyles } from "../../css";
import { BaseButton, type BaseButtonProps } from "../base-button";
import {
  createButtonStylesWaterfall,
  useButtonStylesWaterfall,
} from "../styles";

const buttonStyles = createButtonStylesWaterfall({
  idle: {
    mobile: [
      {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 10,
        height: "100%",
        width: 50,
        border: "none",
        cursor: "pointer",
        pointerEvents: "auto",
      },
    ],
  },
  disabled: {
    common: { display: "none" },
  },
});

type FilterScrollButtonProps = {
  text: string;
  icon?: ReactNode;
  clearable?: boolean;
  onClear?: () => void;
} & Pick<
  BaseButtonProps,
  "disabled" | "onPress" | "triggerRef" | "triggerProps" | "styles"
>;

export const FilterScrollButton = ({
  text,
  icon,
  ...baseProps
}: FilterScrollButtonProps) => {
  const { waterfall } = useButtonStylesWaterfall(buttonStyles);

  return (
    <BaseButton type="button" waterfall={waterfall} {...baseProps}>
      {icon}
    </BaseButton>
  );
};

const leftButtonStyles = {
  common: createStaticStyles.clean({
    left: 0,
    background: `linear-gradient(to right, ${colors.principal.ebblue} 60%, transparent)`,
    paddingInlineStart: 10,
  }),
};

FilterScrollButton.Left = (props: FilterScrollButtonProps) => {
  return (
    <FilterScrollButton
      {...props}
      styles={css([props.styles, leftButtonStyles.common])}
      icon={<icons.DesktopArrowLeft color={colors.principal.white} />}
    />
  );
};

const rightButtonStyles = {
  common: createStaticStyles.clean({
    right: 0,
    background: `linear-gradient(to left, ${colors.principal.ebblue} 60%, transparent)`,
    paddingInlineEnd: 10,
    alignItems: "center",
    justifyContent: "flex-end",
  }),
};

FilterScrollButton.Right = (props: FilterScrollButtonProps) => {
  return (
    <FilterScrollButton
      {...props}
      styles={css([props.styles, rightButtonStyles.common])}
      icon={<icons.DesktopArrowRight color={colors.principal.white} />}
    />
  );
};
